import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISubscription } from '../models/subscription.model';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IBaseTableResult } from '../models/table.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  viewSubscription(subscriptionId: number): Observable<ISubscription> {
    return this.http.get<ISubscription>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`
    );
  }

  updateSubscription(
    subscriptionId: number,
    subscriptionInfo: ISubscription
  ): Observable<{ subscription_id: number }> {
    return this.http.put<{ subscription_id: number }>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`,
      {
        ...subscriptionInfo,
      }
    );
  }

  createSubscription(
    subscriptionInfo: ISubscription
  ): Observable<{ subscription_id: number }> {
    return this.http.post<{ subscription_id: number }>(
      environment.apiUrl + '/v1/subscriptions',
      {
        ...subscriptionInfo,
      }
    );
  }

  deleteSubscription(subscriptionId: number): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(
      environment.apiUrl + `/v1/subscriptions/${subscriptionId}`
    );
  }

  constructor(private http: HttpClient) {}
}
